import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Chrome = createReactComponent("Chrome", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}], ["circle", {
  cx: "12",
  cy: "12",
  r: "4",
  key: "7pwehp"
}], ["line", {
  x1: "21.17",
  y1: "8",
  x2: "12",
  y2: "8",
  key: "1mge5x"
}], ["line", {
  x1: "3.95",
  y1: "6.06",
  x2: "8.54",
  y2: "14",
  key: "1td8ah"
}], ["line", {
  x1: "10.88",
  y1: "21.94",
  x2: "15.46",
  y2: "14",
  key: "k3fms2"
}]]]);
export default Chrome;